"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _GradientButton = _interopRequireDefault(require("../buttons/GradientButton"));
var _Button = _interopRequireDefault(require("../buttons/Button"));
var _helpers = require("../../utils/helpers");
var _CtaBlockModule = _interopRequireDefault(require("../../scss/blocks/CtaBlock.module.scss"));
function CtaBlock({
  title = '',
  titleImageUrl = ``,
  content = ``,
  type = `internal-link`,
  cta = {
    label: ``,
    href: ``,
    type: ``
  },
  ctaButtonStyle = `gradient`,
  btnGradientStartColor = ``,
  btnGradientEndColor = ``,
  btnFlatColors = {
    bgColor: ``,
    bgHoverColor: ``,
    color: ``,
    hoverColor: ``,
    borderColor: ``,
    borderHoverColor: ``
  }
}) {
  const CTA = ctaButtonStyle === 'gradient' ? _GradientButton.default : _Button.default;
  const CTAColorAttrs = ctaButtonStyle === 'gradient' ? {
    gradientStartColor: btnGradientStartColor,
    gradientEndColor: btnGradientEndColor
  } : {
    customColors: btnFlatColors
  };
  const ctaDataToTypes = {
    'play-video': {
      label: `View Promo`,
      target: null,
      rel: null
    },
    'internal-link': {
      label: `View More`,
      target: '_self',
      rel: null
    },
    'external-link': {
      label: `Learn More`,
      target: '_blank',
      rel: 'noreferrer'
    }
  };
  const handleClick = e => {
    console.log('cta clicked', e);
  };
  return /*#__PURE__*/_react.default.createElement("cta-block", {
    style: {
      '--title-image': `url(${titleImageUrl})`
    }
  }, title !== '' && /*#__PURE__*/_react.default.createElement("h1", {
    className: (0, _helpers.classes)(['h2', titleImageUrl ? _CtaBlockModule.default['cta-block__title-img'] : null])
  }, titleImageUrl ? /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, title) : (0, _htmlReactParser.default)(title)), content !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: _CtaBlockModule.default['cta-block__content']
  }, typeof content === 'string' ? (0, _htmlReactParser.default)(content) : content), /*#__PURE__*/_react.default.createElement("cta-wrapper", null, /*#__PURE__*/_react.default.createElement(CTA, (0, _extends2.default)({
    classname: (0, _helpers.classes)([_CtaBlockModule.default['cta-block__cta'], 'cta-block__cta']),
    href: cta.href,
    label: cta.label ? cta.label : ctaDataToTypes[type].label,
    onClick: cta.type === 'play-video' ? handleClick : () => true,
    rel: ctaDataToTypes[type].rel,
    target: ctaDataToTypes[type].target
  }, CTAColorAttrs))));
}
var _default = exports.default = CtaBlock;